import filters from 'gkSrc/filters'
import utils from '../utils'

export default {
  ...filters,
  /**
   * CDN 的图片处理
   * @see https://help.aliyun.com/document_detail/44688.html?spm=a2c4g.11186623.6.1147.3b4d5b80nblRUg
   * @param {Url}     url               图片地址
   * @param {Object}  options           图片配置
   * @param {Object}  options.crop      裁剪图片
   * @param {Number}  options.crop.x    裁剪区的左上角 x 坐标
   * @param {Number}  options.crop.y    裁剪区的左上角 y 坐标
   * @param {Number}  options.crop.w    裁剪区宽度
   * @param {Number}  options.crop.h    裁剪区高度
   * @param {Object}  options.resize    缩放图片
   * @param {Number}  options.resize.w  缩放宽度
   * @param {Number}  options.resize.h  缩放高度
   */
  image (url, options = {}) {
    return utils.image(url, options)
  },
  /**
   * 给内容中的英文或数字自动增加前后空格
   *
   * @param    {string}  text 要自动加空格的内容
   * @return   {string}       处理完空格后的内容
   */
  formatContent (text) {
    return utils.formatContent(text)
  },
  /**
   * 返回倒计时
   * @param {Number} timeDiff 两个时间戳的时间差
   */
  formatTimeDown (timeDiff) {
    return utils.formatTimeDown(timeDiff)
  },
  formatNumber: function (val) {
    return utils.formatNumber(val)
  },
  formatComment (text) {
    return utils.formatComment(text)
  }
}
